import { useMainStore } from "@/store";
import { defineComponent } from "vue";

export default defineComponent({
    computed: {
        approaches(): any[] {
            return useMainStore().session?.approaches || []
        }
    }
})